<template>
  <div
    class="overlay"
  >
    <img
      v-if="canPlay"
      src="@/assets/play.svg"
      class="icon"
      @click="$emit('close')"
    >
    <loading-state
      v-else
      color="#fff"
    />
    <div class="disclaimer">
      By clicking the button you accept our <a
        href=""
        @click.prevent="showInfoUrlFrame(privacyLink)"
      >{{ privacyText }}</a>
    </div>

    <info-url-frame-component
      v-if="isInfoUrlFrameVisible"
      :info-url="infoUrl"
      @close="onInfoUrlFrameClose"
    />
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';
import useConfig from '@/composables/useConfig';
import InfoUrlFrameComponent from '@/components/InfoUrlFrame.vue';
import LoadingState from '@/components/LoadingState.vue';

export default defineComponent({
  name: 'StartOverlayComponent',
  components: {
    InfoUrlFrameComponent,
    LoadingState,
  },

  emits: ['close'],

  props: {
    canPlay: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    const { currentConfig } = useConfig();
    const isInfoUrlFrameVisible = ref(false);
    const infoUrl = ref(null);

    function showInfoUrlFrame(url) {
      infoUrl.value = url;
      isInfoUrlFrameVisible.value = true;
    }

    function onInfoUrlFrameClose() {
      infoUrl.value = '';
      isInfoUrlFrameVisible.value = false;
    }

    return {
      privacyText: currentConfig.value.customPayload?.privacy_text || 'Privacy Policy',
      privacyLink: currentConfig.value.customPayload?.privacy_url || 'https://humanizing.com/privacy',
      showInfoUrlFrame,
      onInfoUrlFrameClose,
      isInfoUrlFrameVisible,
      infoUrl,
    };
  },
});
</script>

<style lang="scss" scoped>
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  .icon {
    opacity: 0.8;
    border-radius: 100%;
    width: 96px;
    height: 96px;
    transition: all 0.25s ease-in-out;
    filter: drop-shadow(rgba(0, 0, 0, 0.6) 0px 0px 20px);

    @media screen and (min-height: $big_vertical_screen_breakpoint) {
      width: 384px;
      height: 384px;
    }
  }

  &:hover > .icon {
    transform: scale(1.1);
  }

  .disclaimer {
    position: absolute;
    bottom: 8px;
    right: 8px;
    text-align: left;
    width: 143px;
    font-family: 'Roboto', Avenir, Helvetica, Arial, sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: #C6C7C9;

    a {
      color: #1B4FDA;
    }
  }
}
</style>
